import api from './api';

export interface Critere {
  id: string;
  evaluationId: string;
  nom: string;
  description?: string;
  ponderationPct: number;
  ordre: number;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCritereData {
  evaluationId: string;
  nom: string;
  description?: string;
  ponderationPct: number;
  ordre?: number;
}

export interface UpdateCritereData {
  nom?: string;
  description?: string;
  ponderationPct?: number;
  ordre?: number;
}

const criteresService = {
  async getAll(): Promise<Critere[]> {
    const { data } = await api.get('/criteres');
    return data.data || [];
  },

  async getById(id: string): Promise<Critere> {
    const { data } = await api.get(`/criteres/${id}`);
    return data.data;
  },

  async getByEvaluationId(evaluationId: string): Promise<Critere[]> {
    const { data } = await api.get(`/criteres/by-evaluation/${evaluationId}`);
    return data.data || [];
  },

  async create(critereData: CreateCritereData): Promise<Critere> {
    const { data } = await api.post('/criteres', critereData);
    return data.data;
  },

  async update(id: string, critereData: UpdateCritereData): Promise<Critere> {
    const { data } = await api.put(`/criteres/${id}`, critereData);
    return data.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/criteres/${id}`);
  },

  async deleteByEvaluationId(evaluationId: string): Promise<void> {
    await api.delete(`/criteres/by-evaluation/${evaluationId}`);
  }
};

export default criteresService;
